import { render, staticRenderFns } from "./ed-select.vue?vue&type=template&id=793ab40e&scoped=true&"
import script from "./ed-select.ts?vue&type=script&lang=ts&"
export * from "./ed-select.ts?vue&type=script&lang=ts&"
import style0 from "./ed-select.scss?vue&type=style&index=0&id=793ab40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ab40e",
  null
  
)

export default component.exports